import { css } from "@emotion/css"
import { isWithinInterval, subHours } from "date-fns"
import { useMemo } from "react"

import { formatHourMinute, formatYearMonthDay } from "@p-ban/common/src/utils/DateUtils"

import useMaintenanceQuery from "../../api/schedule/useMaintenanceQuery"
import COLOR_CODE from "../../features/oneClickEstimate/pcb/constant/color"

const useMaintenance = () => {
  const [start, end] = useMaintenanceQuery()
  const now = useMemo(() => Date.now(), [])

  // 12時間前から表示を開始する。
  if (start && end && isWithinInterval(now, { start: subHours(start, 12), end })) {
    return {
      isOpen: true,
      startString: `${formatYearMonthDay(start)} ${formatHourMinute(start)}`,
      endString: formatHourMinute(end),
      startDateTime: start.toISOString(),
      endDateTime: end.toISOString(),
    }
  }

  return { isOpen: false }
}

const MaintenanceInfo = () => {
  const { isOpen, startString, endString, startDateTime, endDateTime } = useMaintenance()

  if (!isOpen) {
    return null
  }

  return (
    <div className={styles.wrapper}>
      <span className={styles.info}>
        メンテナンスによるサービス停止予定：<time dateTime={startDateTime}>{startString}</time>～
        <time dateTime={endDateTime}>{endString}</time>
      </span>
    </div>
  )
}

export default MaintenanceInfo

const styles = {
  wrapper: css`
    position: absolute;
    top: 10px;
    left: 0;
    width: 100%;
    color: ${COLOR_CODE.WHITE};
    text-align: center;
  `,
  info: css`
    padding: 3px 20px;
    background-color: orange;
  `,
}
